/*
 * The Aiman Studio — restrained scroll reveals (Phase 5)
 * Progressive enhancement: if JS is disabled or IntersectionObserver is
 * unavailable, content stays fully visible. Reveals are skipped entirely
 * when the visitor prefers reduced motion.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  // Containers that should ease in as they enter the viewport.
  var SELECTORS = [
    '.rich-text__blocks',
    '.ats-signature__content',
    '.ats-signature__media',
    '.collection-list',
    '.card-wrapper',
    '.multicolumn-list',
    '.newsletter__wrapper',
    '.section-header'
  ];

  function init() {
    root.classList.add('ats-reveal-ready');

    var nodes = document.querySelectorAll(SELECTORS.join(','));
    if (!nodes.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ats-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (node) {
      node.classList.add('ats-reveal');
      // Gentle stagger for items sharing a row (product/collection grids).
      var siblingIndex = 0;
      var prev = node.previousElementSibling;
      while (prev) {
        siblingIndex++;
        prev = prev.previousElementSibling;
      }
      if (siblingIndex) {
        node.style.transitionDelay = Math.min(siblingIndex % 4, 3) * 80 + 'ms';
      }
      observer.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
